import { render } from "./EmptyBookshelfIllustration.vue?vue&type=template&id=ccd0df72"
import script from "./EmptyBookshelfIllustration.vue?vue&type=script&lang=js"
export * from "./EmptyBookshelfIllustration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__